<template>
    <DsModalDialog
        model-value
        :top-divider-visible="false"
        :bottom-divider-visible
        :has-dialog-close-btn="false"
        @update:model-value="handleModalClosed"
        :animate
        :css-class="['ds-modal-alert', modalClass]"
    >
        <template #top>
            <WebpImage
                alt="Error kuličník"
                :src="'/frontend/web' + alertImageSrc"
                width="148"
                height="80"
                v-if="alertImageSrc"
                css-class="ds-modal-alert__image"
                class="ds-modal-alert__picture"
            />
            <DsTopSlotHeadlineSubheadline :headline="title" :subheadline="subText" />
        </template>
        <template #bottom>
            <DsButton
                v-if="btnConfirmText"
                :href="btnConfirmHref"
                class="ds-modal-alert__button"
                @click="ctaClickHandler"
                >{{ btnConfirmText }}</DsButton
            >
            <DsButton
                class="ds-modal-alert__button"
                :class="[btnCloseClass, { 'ds-modal-alert__button--no-margin': bottomDividerVisible }]"
                @click="handleModalClosed"
                >{{ btnCloseText }}</DsButton
            >
            <span v-if="errorCode" class="ds-modal-alert__code">ecode: {{ errorCode }}</span>
        </template>
    </DsModalDialog>
</template>

<script lang="ts" setup>
import { getCurrentInstance, nextTick } from "vue";
import DsModalDialog from "../modal-dialog/ds-modal-dialog.vue";
import DsTopSlotHeadlineSubheadline from "../top-slot/ds-top-subheadline.vue";
import DsButton from "../button/ds-button.vue";
import WebpImage from "../image/webp-image.vue";
import { DsModalAlertModel } from "./ds-modal-alert-model";

const app = getCurrentInstance();

const props = withDefaults(defineProps<DsModalAlertModel>(), {
    btnCloseText: "OK",
    bottomDividerVisible: false,
    animate: true,
    alertImageSrc: null,
    href: null,
});

const handleModalClosed = () => {
    nextTick(() => {
        app.appContext.app.unmount();
    });
};

const ctaClickHandler = () => {
    if (props.btnConfirmClickHandler) {
        props.btnConfirmClickHandler();
    }

    handleModalClosed();
};
</script>
